// File: /opt/dev_environment/assets/workspace/app-init/src/constants/stagedVerbConstants.js

/**
 * Constants for the staged verb conjugation system.
 */

export const VERB_STATUSES = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  READY: 'ready',
  IMPORTED: 'imported',
  ERROR: 'error',
};

export const VERB_STATUS_CONFIG = {
  pending: { label: 'Ausstehend', color: '#999999', icon: '⏳', bgColor: 'rgba(153,153,153,0.1)' },
  processing: { label: 'Wird verarbeitet', color: '#FF8F00', icon: '⚙️', bgColor: 'rgba(255,143,0,0.1)' },
  ready: { label: 'Bereit', color: '#4CAF50', icon: '✅', bgColor: 'rgba(76,175,80,0.1)' },
  imported: { label: 'Importiert', color: '#42A5F5', icon: '📥', bgColor: 'rgba(66,165,245,0.1)' },
  error: { label: 'Fehler', color: '#E53935', icon: '❌', bgColor: 'rgba(229,57,53,0.1)' },
};

export const TENSE_KEYS = [
  'presente',
  'passato_prossimo',
  'imperfetto',
  'futuro_semplice',
  'condizionale_presente',
];

export const TENSE_CONFIG = {
  presente: { label: 'Presente', germanLabel: 'Präsens' },
  passato_prossimo: { label: 'Passato Prossimo', germanLabel: 'Perfekt' },
  imperfetto: { label: 'Imperfetto', germanLabel: 'Imperfekt' },
  futuro_semplice: { label: 'Futuro Semplice', germanLabel: 'Futur I' },
  condizionale_presente: { label: 'Condizionale Presente', germanLabel: 'Konditional I' },
};

export const PERSON_KEYS = ['io', 'tu', 'lui_lei', 'noi', 'voi', 'loro'];

export const PERSON_CONFIG = {
  io: { label: 'io', germanLabel: 'ich' },
  tu: { label: 'tu', germanLabel: 'du' },
  lui_lei: { label: 'lui/lei/Lei', germanLabel: 'er/sie/Sie' },
  noi: { label: 'noi', germanLabel: 'wir' },
  voi: { label: 'voi', germanLabel: 'ihr' },
  loro: { label: 'loro', germanLabel: 'sie' },
};

export const VERB_GROUP_LABELS = {
  are: '-are',
  ere: '-ere',
  ire: '-ire',
  ire_isc: '-ire (isc)',
  irregular: 'unregelmäßig',
};

/**
 * Calculate how many cards will be created for given verbs and tenses.
 */
export function calculateImportCardCount(verbCount, selectedForms) {
  const personsPerTense = 6;
  return verbCount * selectedForms.length * personsPerTense;
}